import * as React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import { useI18n } from "../../i18n/I18nProvider";

export default function ShareCompletedScreen(props: {
  handlePageChange: (page: string) => void;
}) {
  const { handlePageChange } = props;
  const { lang } = useI18n();
  const isDE = lang === "de";

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 48px)",
        width: "100%",
        px: { xs: 2, sm: 3 },
        py: { xs: 3, sm: 6 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `
          radial-gradient(circle at 20% 20%, rgba(251, 2, 2, 0.08), transparent 40%),
          radial-gradient(circle at 80% 30%, rgba(255, 0, 0, 0.06), transparent 40%),
          #111010
        `,
      }}
    >
      <Paper
        sx={{
          width: { xs: "100%", sm: "min(88vw, 780px)", md: "min(78vw, 860px)" },
          borderRadius: 5,
          p: { xs: 4, sm: 6, md: 7 },
          border: "1px solid rgba(255,255,255,0.14)",
          background:
            "linear-gradient(180deg, rgba(49,32,32,0.95), rgba(34,21,21,0.94))",
          boxShadow: "0 24px 65px rgba(0,0,0,0.45)",
          textAlign: "center",
        }}
      >
        <Stack spacing={4} alignItems="center">
          <Box
            sx={{
              width: 74,
              height: 74,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.16)",
              boxShadow: "0 18px 42px rgba(0,0,0,0.28)",
            }}
          >
            <GroupsIcon sx={{ color: "#f05969", fontSize: 34 }} />
          </Box>

          <Stack spacing={1.5} alignItems="center">
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: "1.7rem", sm: "2.35rem" },
                fontWeight: 950,
                lineHeight: 1.15,
              }}
            >
              {isDE
                ? "Du hast GEMEINSAM bereits abgeschlossen."
                : "You already completed SHARE."}
            </Typography>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.78)",
                maxWidth: 620,
                lineHeight: 1.65,
                fontSize: { xs: "1rem", sm: "1.08rem" },
              }}
            >
              {isDE
                ? "Deine Antworten sind gespeichert. Du kannst zur Homepage zurückkehren oder den GEMEINSAM-Teil erneut durchgehen."
                : "Your answers are saved. You can return to the home screen or retake the SHARE section."}
            </Typography>
          </Stack>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <Button
              variant="outlined"
              onClick={() => handlePageChange("VibeQuestions:share")}
              sx={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 900,
                px: 4,
                py: 1.25,
                borderColor: "rgba(255,255,255,0.4)",
                color: "#fff",
                "&:hover": {
                  borderColor: "#fff",
                  backgroundColor: "rgba(255,255,255,0.08)",
                },
              }}
            >
              {isDE ? "GEMEINSAM erneut machen" : "Retake SHARE section"}
            </Button>

            <Button
              variant="contained"
              onClick={() => handlePageChange("JourneyPillars")}
              sx={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 900,
                px: 4,
                py: 1.25,
                background: "linear-gradient(90deg, #b50d20, #d6293e)",
                "&:hover": {
                  background: "linear-gradient(90deg, #9f0b1c, #c32136)",
                },
              }}
            >
              {isDE ? "Zurück zur Homepage" : "Back to Homepage"}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
